<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title>REPORTE DE PAGOS
                        <v-spacer />
                        <v-btn @click="openDialog(null)" text color="primary" v-if="loadedData">agregar pago</v-btn>
                    </v-card-title>
                    <v-card-text>

                        <v-col cols=12 class="d-flex justify-end" style="font-size: 2em;">
                            {{ total.toLocaleString('es-VE') }} USDT
                        </v-col>

                        <v-btn-toggle v-model="option" tile color="primary" group>
                            <v-btn @click="findPayments('today')" value="today">
                                HOY
                            </v-btn>

                            <v-btn @click="findPayments('yesterday')" value="yesterday">
                                AYER
                            </v-btn>

                            <v-btn @click="findPayments('week')" value="week">
                                SEMANA
                            </v-btn>

                            <v-btn @click="findPayments('month')" value="month">
                                MES
                            </v-btn>
                        </v-btn-toggle>

                        <v-col cols="12" class="d-flex justify-center" v-if="loadingData">
                            <v-progress-circular size="60" width="2" color="primary" indeterminate />
                        </v-col>

                        <v-col cols=12 v-if="loadedData">
                            <v-data-table @click:row="openDialog" class="mt-10" :items="payments" :headers="headers"
                                :items-per-page="20">
                                <!-- item cuenta -->
                                <template v-slot:[`item.amount`]="{ item }">
                                    {{ `${item.amount} USDT` }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- dialogo de registro y edicion de pago -->
        <v-dialog v-model="dialog" width="1000" persistent>
            <v-card>
                <v-card-title>{{ title }}</v-card-title>
                <v-card-text>
                    <v-form v-model="valid" ref="form">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="code" :rules="rulesId" outlined label="Codigo" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field outlined v-model="createdDate" label="Fecha del pago" readonly
                                            v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="createdDate" @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field :rules="rulesTime" v-model="time" outlined label="Hora del pago" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field prefix="USDT" outlined :rules="rulesAmount" v-model="amount"
                                    label="Monto del pago" type="number" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select :rules="rulesAccount" :items="accounts" item-value="id" item-text="name"
                                    v-model="accountId" outlined label="Cuenta del pago" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn :loading="loadingDelete" v-if="schema == 'edit'" @click="deletePayment" text
                        color="red">elimnar
                        pago</v-btn>
                    <v-spacer />
                    <v-btn @click="closeDialog" text color="red">cancelar</v-btn>
                    <v-btn text color="primary" @click="process" :loading="loadingProcess">aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

export default {

    beforeMount() {
        this.loadedData = false;
        this.loadingData = true;

        this.title = this.schema == 'new' ? 'Registrar pago' : 'Editar pago';
        this.$store.dispatch("findAccountsAction").then(res => {
            this.accounts = res;
            this.findPayments();
        })

    },

    data() {
        return {
            total: 0,
            loadingDelete: false,
            id: 0,
            schema: "new",
            code: "",
            loadedData: false,
            loadingData: true,
            option: "today",
            payments: [],
            loadingProcess: false,
            accounts: [],
            valid: false,
            accountId: 0,
            amount: 0,
            time: "",
            title: " Registrar pago",
            createdDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            token: this.$route.params.token,
            dialog: false,
            headers: [
                {
                    text: "Codigo",
                    value: "code",
                    width: "20%",
                },
                {
                    text: "Fecha",
                    value: "date",
                    width: "20%",
                },
                {
                    text: "Hora",
                    value: "time",
                    width: "20%",
                },
                {
                    text: "Monto",
                    value: "amount",
                    width: "20%",
                },
                {
                    text: "Cuenta",
                    value: "account.name",
                    width: "20%",
                },
            ],

            rulesTime: [
                (value) => (value && value.length >= 4 || "Ingrese la hora del pago")
            ],

            rulesAmount: [(value) => (value && value.toString().length > 0 || "Ingrese el monto del pago")],

            rulesAccount: [
                (value) => (value && value > 0 || "Seleccione la cuenta del pago")
            ],

            rulesId: [(value) => (value && value.length > 0 || "Ingrese el codigo de la operacion")],

        }
    },

    watch: {
        payments() {
            this.getTotals();
        }
    },

    methods: {
        openDialog(value) {
            this.dialog = true;

            if (value) {
                this.amount = value.amount;
                this.createdDate = value.date;
                this.accountId = value.account.id;
                this.time = value.time;
                this.code = value.code;
                this.id = value.id;
                this.schema = "edit"
            } else {
                this.schema = "new"
                this.clear();
            }
        },

        closeDialog() {
            this.dialog = false;
        },

        process() {
            if (this.valid) {
                this.loadingProcess = true;

                let payload = {
                    date: this.createdDate,
                    time: this.time,
                    amount: this.amount,
                    account_id: this.accountId,
                    code: this.code,
                    id: this.schema == "edit" ? this.id : 0,
                }

                let path = this.schema == "new" ? "storeAction" : "updateAction"

                setTimeout(() => {
                    this.$store.dispatch(path, payload).then((res) => {
                        if (this.schema == "new")
                            this.payments.push(res);
                        else {
                            let index = this.payments.findIndex((p) => p.id == this.id);
                            this.payments.splice(index, 1, res);
                            this.closeDialog();
                        }
                        this.loadingProcess = false;
                        this.clear();
                    })
                        .catch(() => {
                            this.loadingProcess = false;
                        })
                }, 500);

            } else {
                this.$refs.form.validate();
            }
        },

        clear() {
            this.id = "";
            this.code = "";
            this.time = "";
            this.amount = 0;
            this.accountId = 0;
            this.createdDate = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            if (this.$refs.form)
                this.$refs.form.resetValidation();
        },

        findPayments(option = 'today') {
            this.loadedData = false;
            this.loadingData = true;
            this.total = 0;
            setTimeout(() => {
                this.$store.dispatch("findPayments", { option: option }).then((res) => {
                    this.payments = res;
                    this.loadedData = true;
                    this.loadingData = false;
                })
            }, 500);
        },

        deletePayment() {
            this.$confirm({
                message: `Quieres eliminar este pago?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDelete = true;
                        setTimeout(() => {
                            this.$store
                                .dispatch("deletePaymentAction", { paymentId: this.id })
                                .then(() => {
                                    this.loadingDelete = false;
                                    let index = this.payments.findIndex((p) => p.id == this.id);
                                    if (index > -1) {
                                        this.payments.splice(index, 1);
                                        this.closeDialog();
                                        this.clear();
                                    }
                                });
                        }, 500);
                    }
                },
            });

        },

        getTotals() {
            this.total = 0;
            this.payments.forEach(element => {
                this.total += parseFloat(element.amount);
            });
        }
    },
}

</script>
